import TextItem from './TextItem';
import { TextItemProps, TextItemValueProps } from './types';

export type { TextItemProps, TextItemValueProps };
export default TextItem;
